import React from 'react'
import { FormattedMessage } from 'react-intl'

import { TopbarLeftArea } from '../Instore/components/Header/Topbar'
import { TextWithEllipsis } from '../../ui/components/TextWithEllipsis'

export const SalesInProgressScreen = () => {
  return (
    <TopbarLeftArea>
      <TextWithEllipsis variant="title2">
        <FormattedMessage id="menu-orders" />
      </TextWithEllipsis>
    </TopbarLeftArea>
  )
}
